import { Component, OnInit, Inject } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { FormGroup, FormControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ManifestoEmbarquePainelService } from 'src/app/services/manifesto-embarque-painel.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { take } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
import { ManifestoService } from 'src/app/services/manifesto/manifesto.service';

@Component({
  selector: 'app-modal-manifesto-ressalva',
  templateUrl: './modal-manifesto-ressalva.component.html',
  styleUrls: ['./modal-manifesto-ressalva.component.scss']
})
export class ModalManifestoRessalvaComponent implements OnInit {

  public modalItem: any;
  public tiposRessalva: any[];
  public pedidoIds: any[];
  public pedidoEtiquetas: any[] = [];
  public isLoading = false;
  public meRessalvaCollection: MatTableDataSource<any> = new MatTableDataSource<any>();
  public ressalvaForm: FormGroup = new FormGroup({
    pedidoId: new FormControl(),
    tipoRessalvaId: new FormControl(),
    observacao: new FormControl(),
  });

  public displayedColumns: string[] = [
    'pedidoId'
  ];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<ModalManifestoRessalvaComponent>,
    private service: ManifestoService,
    private meService: ManifestoEmbarquePainelService,
    public snackBar: MatSnackBar
  ) {
    this.modalItem = data?.item;
    this.meRessalvaCollection.data = []
    this.pedidoIds = this.modalItem.pedidoIds;
    this.pedidoEtiquetas = this.modalItem.pedidoEtiquetas;
  }

  ngOnInit() {
    let array = [];
    this.loadTiposRessalva();
    if (this.modalItem.isRessalvaPorVolume === true) {
      this.displayedColumns.push('volumeId');
      this.pedidoEtiquetas.forEach(element => {
        element.volumes.forEach(subElement => {
          array.push({ pedidoId: element.pedidoId, volumeId: subElement.volumeId });
        });
      });
      this.meRessalvaCollection.data = array;
    }
    else
      this.meRessalvaCollection.data = this.pedidoIds.map(p => { return { pedidoId: p } });
  }

  public saveRessalva() {
    var ressalva = this.ressalvaForm.value;
    ressalva["manifTransfId"] = this.modalItem.manifTransfId;
    ressalva["manifDevTranspId"] = this.modalItem.manifDevTranspId;

    if (ressalva["manifTransfId"])
      ressalva["manifTransfId"] = this.modalItem.manifTransfId.toString().substring(0, this.modalItem.manifTransfId.toString().length - 1);

    if (ressalva["manifDevTranspId"])
      ressalva["manifDevTranspId"] = this.modalItem.manifDevTranspId.toString().substring(0, this.modalItem.manifDevTranspId.toString().length - 1);

      if (this.modalItem.isRessalvaPorVolume === true )
        ressalva["pedidoEtiquetas"] = this.pedidoEtiquetas.map((p) => { return { pedidoId: p.pedidoId, pedidoEtiquetaIds: p.volumes.map(q => q.pedidoEtiquetaId) } });
      else
        ressalva["pedidoIds"] = this.pedidoIds;

      this.isLoading = true;
      this.service.createRessalva(ressalva)
      .pipe(take(1)).
      subscribe(
        () => {
          this.isLoading = false;
          this.openSnackBar('Ressalva incluída com sucesso!', 'Ok', 3000);
          this.dialogRef.close();
        },
        (errorResponse: HttpErrorResponse) => {
          this.isLoading = false;
          this.threatError(errorResponse);
          this.dialogRef.close();
        });
  }

  private loadTiposRessalva() {
    this.meService.getTiposRessalva()
      .pipe(take(1))
      .subscribe(response => {
        this.tiposRessalva = response.body;
      });
  }

  private threatError(errorResponse: HttpErrorResponse) {
    if (errorResponse.status === 409) {
      this.openSnackBar(errorResponse.error, 'Ok', 3000, 'danger-snackbar');
    }
    else {
      this.openSnackBar('Desculpe, aconteceu um erro!', 'Ok', 3000, 'danger-snackbar');
    }
  }

  private openSnackBar(message: string, action: string, duration: number, panelClass?: string): any {
    this.snackBar.open(message, action, { duration, panelClass });
  }
}
